import React from "react";
import withRouter from "../hooks/withRouter"
import { Navigate, Route, Routes} from "react-router-dom";
import { Home } from "../pages/home";
import { Shadowing } from "../pages/shadowing";
// import { Portfolio } from "../pages/portfolio";
// import { ContactUs } from "../pages/contact";
// import { About } from "../pages/about";
import { Socialicons } from "../components/socialicons";
import { CSSTransition, TransitionGroup } from "react-transition-group";

const AnimatedRoutes = withRouter(({ location }) => (
  <TransitionGroup>
    <CSSTransition
      key={location.key}
      timeout={{
        enter: 400,
        exit: 400,
      }}
      classNames="page"
      unmountOnExit
    >
      <Routes location={location}>
        <Route exact path="/" element={<Home />} />
        {/* Route cụ thể phải nằm TRƯỚC catch-all bên dưới */}
        <Route path="/shadowing" element={<Shadowing />} />
        {/* <Route path="/about" element={<About />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/contact" element={<ContactUs />} /> */}
        {/* <Route path="*" element={<Home />} /> */}
        <Route path="*" element={<Navigate to="/" replace />}
    />
      </Routes>
    </CSSTransition>
  </TransitionGroup>
));

function AppRoutes() {
  return (
    <div className="s_c">
      <AnimatedRoutes />
      <Socialicons />
    </div>
  );
}

export default AppRoutes;
